import React from 'react';
import { makeStyles, Theme } from '@lifeomic/chroma-react/styles';
import { GetClasses } from '@lifeomic/chroma-react/typeUtils';
import MaskedInput, { MaskedInputProps } from 'react-text-mask';
import {
  TextFieldProps,
  TextField,
} from '@lifeomic/chroma-react/components/TextField';

export const useStyles = makeStyles((_theme: Theme) => ({
  root: {},
}));

export type MaskedTextFieldClasses = GetClasses<typeof useStyles>;

export interface MaskedTextFieldOwnProps {
  input: TextFieldProps;
}

export type MaskedTextFieldProps = MaskedTextFieldOwnProps & MaskedInputProps;

const MaskedTextField = (props: MaskedTextFieldProps) => {
  const { input, ...toPass } = props;

  return (
    <MaskedInput
      {...toPass}
      render={(ref, props) => {
        return <TextField ref={ref} {...props} {...input} />;
      }}
    />
  );
};

export default React.memo(MaskedTextField);
